import * as React from 'react';
import { EInputType, GeoSuggest, ETruncation } from '@cian/geosuggest-widget';
import cn from 'clsx';

import { ErrorPopover } from '../ErrorPopover';

import * as styles from './styles.css';
import { TAddressInputComponentProps } from '../../utils/types';

export const AddressInput: React.FC<TAddressInputComponentProps> = props => {
  const geoSuggestProps: React.ComponentProps<typeof GeoSuggest> = {
    value: props.value,
    selectedValue: props.value,
    error: props.addressGeoSuggest.error,
    suggestData: props.addressGeoSuggest.suggestData,
    inputType: EInputType.mobile,
    inputStyle: [props.className, props.errorMessage ? { border: '1px solid #ff1f34' } : {}],
    onItemClick: props.onItemClick,
    onValueChange: props.onValueChange,
    popupStyle: styles['suggest-popup'],
    placeholder: props.placeholder,
    itemsTruncation: ETruncation.Two,
    flip: false,
  };

  return (
    <div
      className={cn(styles['input-container'], styles['input-container-not-desktop'])}
      onClick={props.onInputTagClick}
    >
      <ErrorPopover tooltipContent={props.errorMessage || ''} wrapWith="div">
        <GeoSuggest {...geoSuggestProps} />
      </ErrorPopover>
    </div>
  );
};

AddressInput.displayName = 'AddressInput';
